import { FloatingServiceMenu, Footer, Header, Page, PageTransition } from '@components/Page'
import { pickSeoProps } from '@components/Page/Page'
import { DigitalProductList } from '@components/_digital-products/digital-product-list'
import { FeaturedDigitalProduct } from '@components/_digital-products/featured-digital-product'
import { Heading } from '@components/gassan-ui/Typography/Heading'
import { Text } from '@components/gassan-ui/Typography/Text'
import { Box, Container } from '@gassan-ui'
import { SingleItemResponse } from '@lib/kontent'
import { CbHtmlEmbed } from '@lib/kontent/models/CbHtmlEmbed'
import { DigitalProductPage as DigitalProductModel } from '@lib/kontent/models/DigitalProductPage'
import { rem } from 'polished'
import { FC } from 'react'

type Props = SingleItemResponse<DigitalProductModel>

const DigitalProductPage: FC<Props> = ({ item, modular_content }) => {
  const otherProducts = item.elements.other_products.modular_content.map(
    (key) => modular_content[key].elements,
  ) as CbHtmlEmbed[]
  return (
    <Page {...pickSeoProps(item.elements)}>
      <FloatingServiceMenu />
      <Header initialVariant="absolute" />
      <PageTransition>
        <Container maxWidth={rem(1450)}>
          <Box
            pt={{ _: '1.5rem', small: '3rem', large: '5rem', xlarge: '7rem' }}
            pb={{ _: '2.5rem', large: '4rem', xlarge: '5rem' }}
            maxWidth="35rem"
            textAlign={{ _: 'center', large: 'left' }}
            m={{ _: '0 auto', large: 'initial' }}
          >
            <Heading variant="h1" as="h1" className="mb-4 sm:mb-6">
              {item.elements.title.value}
            </Heading>
            <Text className="mb-0">{item.elements.page_description.value}</Text>
          </Box>
          <FeaturedDigitalProduct
            title={item.elements.featured_title.value}
            description={item.elements.featured_description.value}
            content={item.elements.featured_html_content}
          />
          {otherProducts && (
            <DigitalProductList items={otherProducts} title={item.elements.other_title.value} />
          )}
        </Container>
        <Footer />
      </PageTransition>
    </Page>
  )
}

export default DigitalProductPage
